var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"customTable":_vm.customTable},on:{"saveModel":function($event){return _vm.sendToShow($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }